import * as React from 'react';
export const IcThinkingCritical = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.17 8.66a1 1 0 100-2 1 1 0 000 2zM21 9h-3.65a1 1 0 100 2H21a1 1 0 000-2zm-8.91-3.25h.75v.75a1 1 0 102 0v-.75h.75a1 1 0 100-2h-.75V3a1 1 0 00-2 0v.75h-.75a1 1 0 100 2zm7.08 5.59a1 1 0 100 2 1 1 0 000-2zm-3 1.44A3 3 0 0114.35 10c-.01-.11-.01-.22 0-.33v-.23h-.22a1.27 1.27 0 01-.34 0A3 3 0 0111 7.56a3 3 0 01-1.86-2.28 6.93 6.93 0 00-5 5.46l-1.08 2.92A1 1 0 004 15h.5v1A3 3 0 007 19v1a1 1 0 001 1h7a1 1 0 001-1v-3.11a6.75 6.75 0 001.41-2.14 2.94 2.94 0 01-1.19-1.97h-.05z'
      fill='currentColor'
    />
  </svg>
);
